import { ExtraPackageDoveIt } from '../../../domain/types';
import { Agent } from '../../../providers/api/dtos';
import { DOCUMENTATION_DOCUMENTS } from './constants';

export function getActualDocumentationDocuments(agent: Agent | undefined) {
  const isPremium = (
    agent && !agent.franchising && agent.configuration?.extraPackages?.allowedExtraPackages?.map((it) => it.name).includes(ExtraPackageDoveIt.PREMIUM_VISIBILITY)
  ) ?? false;

  return DOCUMENTATION_DOCUMENTS(isPremium);
}
